 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Account":"Account","Acount~AddAccount~AddAddress~AddBanner~AddBlog~AddBodyType~AddBrand~AddChargingStation~AddMenu~AddPr~8e9145c1":"Acount~AddAccount~AddAddress~AddBanner~AddBlog~AddBodyType~AddBrand~AddChargingStation~AddMenu~AddPr~8e9145c1","Acount~Product":"Acount~Product","Acount":"Acount","AddAccount":"AddAccount","AddAddress":"AddAddress","AddBanner":"AddBanner","AddBlog~AddProduct~Product~RegistrationUser~SellYourCar":"AddBlog~AddProduct~Product~RegistrationUser~SellYourCar","AddBlog~AddPage~AddProduct~SellYourCar":"AddBlog~AddPage~AddProduct~SellYourCar","AddBlog":"AddBlog","AddProduct~SellYourCar":"AddProduct~SellYourCar","AddProduct":"AddProduct","SellYourCar":"SellYourCar","Home~Page~Product":"Home~Page~Product","Product":"Product","LoginUser~RegistrationUser":"LoginUser~RegistrationUser","RegistrationUser":"RegistrationUser","AddBodyType":"AddBodyType","AddBrand":"AddBrand","AddChargingStation":"AddChargingStation","AddMenu":"AddMenu","AddServiceCenter":"AddServiceCenter","AddSubCategory":"AddSubCategory","Blog":"Blog","ChargingStation":"ChargingStation","Compare":"Compare","EMICalculator":"EMICalculator","SingleOrder":"SingleOrder","TaxCalculator":"TaxCalculator","AddBatteryType":"AddBatteryType","AddPage":"AddPage","AddCategory":"AddCategory","AddColor":"AddColor","AddInsuranceCompany":"AddInsuranceCompany","AddYear":"AddYear","Address":"Address","Banner":"Banner","BatteryType":"BatteryType","BodyType":"BodyType","Booking":"Booking","Brand":"Brand","Categories":"Categories","ChangePassword":"ChangePassword","ChangringStation":"ChangringStation","Checkout":"Checkout","Color":"Color","Community":"Community","Contact":"Contact","Disclamer":"Disclamer","ForgetPasswordUser":"ForgetPasswordUser","ForgetPasswordVerify":"ForgetPasswordVerify","Home":"Home","Page":"Page","Insurance":"Insurance","InsuranceCompany":"InsuranceCompany","Log":"Log","LoginUser":"LoginUser","Menus":"Menus","MyPayment":"MyPayment","MyVehicle":"MyVehicle","Order":"Order","PrivacyPolicy":"PrivacyPolicy","RefundnReturn":"RefundnReturn","Review":"Review","Reviewed":"Reviewed","SavedCar":"SavedCar","Search":"Search","ServiceCenter":"ServiceCenter","SingleBooking":"SingleBooking","TermsnCondition":"TermsnCondition","Thankyou":"Thankyou","ToBeReviewed":"ToBeReviewed","Year":"Year"}[chunkId]||chunkId) + "." + {"Account":"d68463ae","Acount~AddAccount~AddAddress~AddBanner~AddBlog~AddBodyType~AddBrand~AddChargingStation~AddMenu~AddPr~8e9145c1":"3e3454dd","Acount~Product":"d848ae78","Acount":"dcdae505","AddAccount":"4b992138","AddAddress":"30ebe671","AddBanner":"c47c5a21","AddBlog~AddProduct~Product~RegistrationUser~SellYourCar":"da43ccb9","AddBlog~AddPage~AddProduct~SellYourCar":"30fa692e","AddBlog":"814ca9e9","AddProduct~SellYourCar":"fba48719","AddProduct":"153f177b","SellYourCar":"6fb61aa7","Home~Page~Product":"0f906906","Product":"f538f498","LoginUser~RegistrationUser":"10a32ebb","RegistrationUser":"37f920e5","AddBodyType":"733c3eeb","AddBrand":"a96fc16e","AddChargingStation":"4cf971cf","AddMenu":"d2c1fb49","AddServiceCenter":"3735140e","AddSubCategory":"c0769df2","Blog":"1cb75b7d","ChargingStation":"745217d1","Compare":"6f3f75e1","EMICalculator":"af865a5c","SingleOrder":"4a2cd59a","TaxCalculator":"3e5da21d","AddBatteryType":"a86939e9","AddPage":"1a5ffbcd","AddCategory":"f88547ca","AddColor":"740df4ee","AddInsuranceCompany":"d3a6c086","AddYear":"41e9a5c7","Address":"e561d8d2","Banner":"61281d4f","BatteryType":"ecd193c3","BodyType":"8793f682","Booking":"9bca42b9","Brand":"5bbe0910","Categories":"0539a746","ChangePassword":"48ad17f3","ChangringStation":"1d021a28","Checkout":"cd0cd2ea","Color":"8c420ed2","Community":"ce7b49a1","Contact":"388d3c01","Disclamer":"a1664aea","ForgetPasswordUser":"750388f8","ForgetPasswordVerify":"ec3ef689","Home":"68dd879d","Page":"15379431","Insurance":"7b66a132","InsuranceCompany":"976c358f","Log":"d1770d75","LoginUser":"016714d1","Menus":"d593e0ac","MyPayment":"bfd92785","MyVehicle":"d90c1d80","Order":"05d00f9e","PrivacyPolicy":"d6ad0346","RefundnReturn":"f81f846c","Review":"d9ea9e55","Reviewed":"40783aaf","SavedCar":"7efeb03a","Search":"80f81172","ServiceCenter":"de85c5fd","SingleBooking":"83410604","TermsnCondition":"9e0e3043","Thankyou":"7545f763","ToBeReviewed":"a194bffc","Year":"0148232b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Account":1,"Acount~AddAccount~AddAddress~AddBanner~AddBlog~AddBodyType~AddBrand~AddChargingStation~AddMenu~AddPr~8e9145c1":1,"Acount~Product":1,"Acount":1,"AddAccount":1,"AddAddress":1,"AddBanner":1,"AddBlog~AddProduct~Product~RegistrationUser~SellYourCar":1,"AddBlog":1,"AddProduct~SellYourCar":1,"AddProduct":1,"SellYourCar":1,"Home~Page~Product":1,"Product":1,"LoginUser~RegistrationUser":1,"RegistrationUser":1,"AddBodyType":1,"AddBrand":1,"AddChargingStation":1,"AddMenu":1,"AddServiceCenter":1,"AddSubCategory":1,"Blog":1,"ChargingStation":1,"Compare":1,"EMICalculator":1,"SingleOrder":1,"TaxCalculator":1,"AddBatteryType":1,"AddPage":1,"AddCategory":1,"AddColor":1,"AddInsuranceCompany":1,"AddYear":1,"Address":1,"Banner":1,"BatteryType":1,"BodyType":1,"Booking":1,"Brand":1,"Categories":1,"ChangePassword":1,"ChangringStation":1,"Checkout":1,"Color":1,"Community":1,"Contact":1,"Disclamer":1,"ForgetPasswordUser":1,"ForgetPasswordVerify":1,"Home":1,"Page":1,"Insurance":1,"InsuranceCompany":1,"Log":1,"LoginUser":1,"Menus":1,"MyPayment":1,"MyVehicle":1,"Order":1,"PrivacyPolicy":1,"RefundnReturn":1,"Review":1,"Reviewed":1,"SavedCar":1,"Search":1,"ServiceCenter":1,"SingleBooking":1,"TermsnCondition":1,"Thankyou":1,"ToBeReviewed":1,"Year":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Account":"Account","Acount~AddAccount~AddAddress~AddBanner~AddBlog~AddBodyType~AddBrand~AddChargingStation~AddMenu~AddPr~8e9145c1":"Acount~AddAccount~AddAddress~AddBanner~AddBlog~AddBodyType~AddBrand~AddChargingStation~AddMenu~AddPr~8e9145c1","Acount~Product":"Acount~Product","Acount":"Acount","AddAccount":"AddAccount","AddAddress":"AddAddress","AddBanner":"AddBanner","AddBlog~AddProduct~Product~RegistrationUser~SellYourCar":"AddBlog~AddProduct~Product~RegistrationUser~SellYourCar","AddBlog~AddPage~AddProduct~SellYourCar":"AddBlog~AddPage~AddProduct~SellYourCar","AddBlog":"AddBlog","AddProduct~SellYourCar":"AddProduct~SellYourCar","AddProduct":"AddProduct","SellYourCar":"SellYourCar","Home~Page~Product":"Home~Page~Product","Product":"Product","LoginUser~RegistrationUser":"LoginUser~RegistrationUser","RegistrationUser":"RegistrationUser","AddBodyType":"AddBodyType","AddBrand":"AddBrand","AddChargingStation":"AddChargingStation","AddMenu":"AddMenu","AddServiceCenter":"AddServiceCenter","AddSubCategory":"AddSubCategory","Blog":"Blog","ChargingStation":"ChargingStation","Compare":"Compare","EMICalculator":"EMICalculator","SingleOrder":"SingleOrder","TaxCalculator":"TaxCalculator","AddBatteryType":"AddBatteryType","AddPage":"AddPage","AddCategory":"AddCategory","AddColor":"AddColor","AddInsuranceCompany":"AddInsuranceCompany","AddYear":"AddYear","Address":"Address","Banner":"Banner","BatteryType":"BatteryType","BodyType":"BodyType","Booking":"Booking","Brand":"Brand","Categories":"Categories","ChangePassword":"ChangePassword","ChangringStation":"ChangringStation","Checkout":"Checkout","Color":"Color","Community":"Community","Contact":"Contact","Disclamer":"Disclamer","ForgetPasswordUser":"ForgetPasswordUser","ForgetPasswordVerify":"ForgetPasswordVerify","Home":"Home","Page":"Page","Insurance":"Insurance","InsuranceCompany":"InsuranceCompany","Log":"Log","LoginUser":"LoginUser","Menus":"Menus","MyPayment":"MyPayment","MyVehicle":"MyVehicle","Order":"Order","PrivacyPolicy":"PrivacyPolicy","RefundnReturn":"RefundnReturn","Review":"Review","Reviewed":"Reviewed","SavedCar":"SavedCar","Search":"Search","ServiceCenter":"ServiceCenter","SingleBooking":"SingleBooking","TermsnCondition":"TermsnCondition","Thankyou":"Thankyou","ToBeReviewed":"ToBeReviewed","Year":"Year"}[chunkId]||chunkId) + "." + {"Account":"51665a91","Acount~AddAccount~AddAddress~AddBanner~AddBlog~AddBodyType~AddBrand~AddChargingStation~AddMenu~AddPr~8e9145c1":"1cebf3bf","Acount~Product":"83dc1db3","Acount":"530c9009","AddAccount":"d963fd72","AddAddress":"5aba24b4","AddBanner":"59d1d2ca","AddBlog~AddProduct~Product~RegistrationUser~SellYourCar":"b10636dd","AddBlog~AddPage~AddProduct~SellYourCar":"31d6cfe0","AddBlog":"2f1b098b","AddProduct~SellYourCar":"0eb48784","AddProduct":"4d1c2114","SellYourCar":"339cbb9e","Home~Page~Product":"c443e02b","Product":"16f2ecfe","LoginUser~RegistrationUser":"90834c81","RegistrationUser":"90af40b7","AddBodyType":"5680362d","AddBrand":"dd36241f","AddChargingStation":"5643f2d7","AddMenu":"193c7ca7","AddServiceCenter":"a6df8f3a","AddSubCategory":"de4663d6","Blog":"83a1dd51","ChargingStation":"68d9c411","Compare":"f3eb02c5","EMICalculator":"74027e4e","SingleOrder":"63682989","TaxCalculator":"06b29ab5","AddBatteryType":"6d793615","AddPage":"e85da3d5","AddCategory":"b4f5d3d9","AddColor":"4a9a80d5","AddInsuranceCompany":"a51c80b9","AddYear":"09a21e7a","Address":"6e4d24f5","Banner":"fdbc3bfc","BatteryType":"57d8f016","BodyType":"dbbdb230","Booking":"851a4a0b","Brand":"1cf15f1b","Categories":"7bd9c906","ChangePassword":"fca7b7a8","ChangringStation":"a04c78f2","Checkout":"6f4825b8","Color":"d146f5ef","Community":"658749dc","Contact":"7cb1607a","Disclamer":"80653ae8","ForgetPasswordUser":"ce8d6c83","ForgetPasswordVerify":"644a358a","Home":"83d61563","Page":"7ef9bd52","Insurance":"ffd0bb1a","InsuranceCompany":"9a250cc3","Log":"51b46e86","LoginUser":"8ef86b3c","Menus":"7ac07cd4","MyPayment":"49cf4706","MyVehicle":"175dece5","Order":"f0dd05d6","PrivacyPolicy":"f6497b4a","RefundnReturn":"55a98fde","Review":"01f0d4a5","Reviewed":"a15ff7b6","SavedCar":"48c92828","Search":"a6dd79e1","ServiceCenter":"28d2587c","SingleBooking":"050c8c45","TermsnCondition":"8a4e773b","Thankyou":"4771f362","ToBeReviewed":"f3fc9080","Year":"b083f9a1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
